// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QXRn","question":"styles_question__3jaXq","description":"styles_description__3aIdk"};